import { checkIfConditionsMet, getNextStepIndex } from "./handlers";

import { IAppContext } from "../../util/context";
import { StepData } from "../FormViewer/FormViewer.types";
import { trackEvent } from "../../util/functions";

export const handleStepTransition = (context: IAppContext, stepData: StepData) => {
  const { steps, activeStepIndex, updateActiveStepIndex, updateBreadcrumb } = context;
  let nextIndex = getNextStepIndex(activeStepIndex, stepData, steps, context);

  const nextStep = steps[nextIndex];
  if (!nextStep) return ;
  const { stepSettings: [stepSettings] } = nextStep;
  const { hideIfFieldExists } = stepSettings;

  checkIfConditionsMet(hideIfFieldExists) && nextIndex++;
  
  if(nextIndex === 1 && steps.length > 1) {
    trackEvent("formClient.started");
  }

  updateActiveStepIndex(nextIndex);
  updateBreadcrumb(nextIndex);
}